import React from 'react'
import "./About.css"

const About = () => {
  return (
    <div className='about__container'>
      <h3>How I can help you</h3>
      <p>I am an aspiring designer/developer with a background in creative coding and generative art.</p> 
      <p>I specialize in flexible brand identities made with code, web experiences, art prints and installations.</p>
    </div>
  )
}

export default About